import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Row, Col, NavLink } from 'react-bootstrap';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { Button, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getAttentionObservationsById, getEquipmentAlertsById, getEquipmentAlertsByQuery, patchAttentionObservationsRelease } from 'components/axios/equipmentAlertsAxios';
import { deleteMaintenanceTasks, getMaintenanceTasksById } from 'components/axios/maintenanceAxios';
import { getStationsByQuery } from 'components/axios/stationAxios';
import { getEquipmentsById } from 'components/axios/equipmentAxios';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import MainCard from 'components/MainCard';
import FileDownloadIcon from 'components/FileDownloadIcon';
import ConstantInspectionListTable from 'components/table/ConstantInspectionListTable';
import MaintenanceTaskInfoCard from './mainCard/MaintenanceTaskInfoCard';
import AttentionObservationInfoCard from './mainCard/AttentionObservationInfoCard';
import EquipmentAlertInfoCard from './mainCard/EquipmentAlertInfoCard';
import PanoViewerLayer from 'components/layer/PanoViewerLayer';
import ConstantInspectionFollowActionTypeRequestLayer from 'components/layer/ConstantInspectionFollowActionTypeRequestLayer';
import MaintenanceRequestLayer from 'components/layer/MaintenanceRequestLayer';
import EquipmentRemarkModifyLayer from 'components/layer/EquipmentRemarkModifyLayer';
import FileViewerByFileUrl from 'components/FileViewerByFileUrl';
import EquipmentImgFileModifyLayer from 'components/layer/EquipmentImgFileModifyLayer';
import ComprehensiveReportLayer from 'components/layer/ComprehensiveReportLayer';
import { useTheme } from 'components/ThemeContext';

const EquipmentAlertViewMaintenancePage = ({alertId, linkTarget, setIsLoading : setParentIsLoading}) => {
    const { getEnumValueByEnumNameAndCode, role } = useEnumApi();
    const { t } = useTranslation();
    const { mode } = useTheme();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const today = new Date();
    const todayNum = dayjs(today).format("YYYYMMDD");    
    const [previewImage, setPreviewImage] = useState(process.env.PUBLIC_URL+"/img/sample.png");
    const [extension, setExtension] = useState("png");
    const [selectedImg, setSelectedImg] = useState([]);
    const [selectedBp, setSelectedBp] = useState("");

    const [info, setInfo] = useState(null);
    const [station, setStation] = useState(null);
    const [equipmentAlert, setEquipmentAlert] = useState();
    const [equipmentAlerts, setEquipmentAlerts] = useState();
    const [attentionObservation, setAttentionObservation] = useState();
    const [maintenanceTask, setMaintenanceTask] = useState();

    useEffect(() => {
        equipmentAlertInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const equipmentAlertInfo = () => {
        if (alertId) {
            Promise.all([
                getEquipmentAlertsById(alertId).then((data)=>{
                    setEquipmentAlert(data);
                    return data;
                })
            ]).then((res) => {
                if (res && res[0]) {
                    Promise.all([
                        getEquipmentsById(res[0].equipment.id).then((res1)=>{
                            setInfo(res1);
                        }),
                        getStationsByQuery({id:res[0].equipment.station.id}).then((data2)=>{
                            //console.log(data2);
                            if (data2 && data2._embedded) {
                                setStation(data2._embedded.stations[0]);
                            }
                        }),
                        getEquipmentAlertsByQuery({"equipment.id" : res[0].equipment.id, sort : "latestAlertedAt,desc", size : 10}).then((data3)=>{
                            //console.log(data3);
                            if (data3 && data3._embedded) {
                                setEquipmentAlerts(data3._embedded.equipmentAlerts);
                            }
                        })
                    ]).then((res2)=>{
                        // console.log(res);
                        if (res[0] != null && res[0].fllwActionType === 'O2_OBSERVE' && res[0].atentObserv != null) {   // 주의관찰
                            getAttentionObservationsById(res[0].atentObserv.id).then((observe)=>{
                                // console.log(observe);
                                if (observe) {
                                    setAttentionObservation(observe);
                                } else {
                                    setAttentionObservation(null);
                                }
                            })
                        } else if (res[0].fllwActionType === 'O3_MNT') {    // 유지보수
                            //console.log(res[0]);
                            if (res[0].mntTask && res[0].mntTask.id) {
                                getMaintenanceTasksById(res[0].mntTask.id).then((task) => {
                                    //console.log(task);
                                    if (task) {
                                        setMaintenanceTask(task);
                                    } else {
                                        setMaintenanceTask(null);
                                    }
                                })
                            } else {
                                setMaintenanceTask(null);
                            }
                        }
                    })
                }
                //setIsLoading(true);
            })
        }
    }

    useEffect(()=>{
        //console.log(info);
        // if (info && info.imgFiles && info.imgFiles.length > 0) {
        //     setImageFromFile(info.imgFiles[0]);
        // } else {
        //     setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
        // }
        // setSelectedImg(" on");
        // setSelectedBp("");
        if (info) {
          let copy = Array(info.imgFiles?.length).fill("");
          if (info && info.imgFiles && info.imgFiles.length > 0) {
            setImageFromFile(info.imgFiles[0], 1);
            copy[0] = " on";
          } else {
            setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
          }
          setSelectedImg(copy);
          setSelectedBp("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info]);

    const setImageFromFile = ( file , selectIdx ) => {
        setPreviewImage(process.env.REACT_APP_API_URL+"/api/download/"+file?.id);
        setExtension("png");
        
        if (selectIdx <= info.imgFiles.length) {
            let copy = Array(info.imgFiles?.length).fill("");
            copy[selectIdx-1] = " on";
            setSelectedImg(copy);
            setSelectedBp("");
        } else {
            setSelectedImg([]);
            setSelectedBp(" on");
        }
    };

    const setDefaultImageFromFile = ( selectIdx ) => {
        setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
        setExtension("png");
        if (selectIdx <= info.imgFiles.length) {
            let copy = Array(info.imgFiles?.length).fill("");
            copy[selectIdx-1] = " on";
            setSelectedImg(copy);
          setSelectedBp("");
        } else {
          setSelectedImg([]);
          setSelectedBp(" on");
        }
    };

    const risUserModal = (id) => {
      openModal(modals.promptModal, {
          onSubmit : (value) => {
              let body = {
                  id,
                  risUser : value
              }
              patchAttentionObservationsRelease(id, body).then((res) => {
                  setParentIsLoading(false);
                  alertMessage = t('message.common.alert.release.complete');
                  setAlertMessage(alertMessage);
                  handleAlertClick();
              })
          },
          onClose : () => {
              console.log('close');
          },
          message: t('message.common.alert.release.handler.input'),
          originValue : ''
          //label : '비고'
      });
    }

    const handleDeleteBtnClick = (param) => {
        console.log(param)
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            deleteMaintenanceTasks(param).then((res) => {
              document.location.href = '/maintenance-history'+window.location.search;
            }).catch((err)=>{
              console.log(err);
              if (!err.response?.data?.message) {
                alertMessage = err.message;
                setAlertMessage(alertMessage);
                handleAlertClick();
              } else if (err.response.data.message) {
                alertMessage = err.response.data.message;
                setAlertMessage(alertMessage);
                handleAlertClick();
              }
            });
          },
          onClose : () => {
            console.log('close');
          },
          message: t('message.common.alert.maintenance.delete.question'),
        });
      }

    if (station && info) {
      let titleLinkUrl = "../";
      return (
        <div className="sub_container">
            <div className="moni_tit_box" style={{display:"flex", alignItems:"center"}}>
                <h5 style={{color:"#fff", borderRadius:"0"}}>
                {/* <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway.png`} alt='' /></span>&nbsp;
                <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}`}>
                {getEnumValueByEnumNameAndCode("SubwayLine", station.workingPart.subwayLine) && getEnumValueByEnumNameAndCode("SubwayLine", station.workingPart.subwayLine)[0].title} 
                </Link>
                <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}`}>
                &gt; {station.workingPart.name} 
                </Link>
                <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}`}>
                &gt; ({station.code}){station.name}
                </Link>
                <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${info.equipmentCtgr.parent.parent.id}&searchlevel2=${info.equipmentCtgr.parent.id}`}>
                &gt; {info.equipmentCtgr && info.equipmentCtgr.parent && (info.equipmentCtgr.parent.name || '')} 
                </Link>
                <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${info.equipmentCtgr.parent.parent.id}&searchlevel2=${info.equipmentCtgr.parent.id}&searchlevel3=${info.equipmentCtgr.id}`}>
                &gt; {info.equipmentCtgr && (info.equipmentCtgr.name || '')}
                </Link>
                <Link to={`${titleLinkUrl}?searchField=name&searchKeyword=${info.name}&searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${info.equipmentCtgr.parent.parent.id}&searchlevel2=${info.equipmentCtgr.parent.id}&searchlevel3=${info.equipmentCtgr.id}`}>
                &gt; {info.name || ''}
                </Link> */}
                {info.name}({info.equipmentNo})
                </h5>
                &nbsp;<ComprehensiveReportLayer info={info} station={station} previewImage={previewImage} />
            </div>
            <br/>
            <Row>
                <Col sm={4} className="sub_left">
                    <FileViewerByFileUrl fileUrl={previewImage} extension={extension} />
                    <div style={{display:"flex", justifyContent:"space-between", marginTop:"10px", width:"100%"}}>
                        <div className="vr_btn_box">
                            <div>
                                {info?.imgFiles && info.imgFiles.length > 0 ?
                                <div className="vr_btn">
                                    {info.imgFiles.map((img, i)=>{
                                    return (
                                    <Button key={i} variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedImg[i]} color="primary" onClick={()=>setImageFromFile(img, i+1)}>
                                        <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/construction.png`} alt='' /></span>&nbsp;{t('message.common.btn.equipment')}{i+1}
                                    </Button>
                                    )
                                    })}
                                </div>
                                :
                                <div className="vr_btn">
                                    <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} color="primary" onClick={()=>setDefaultImageFromFile(1)}>
                                        <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/construction.png`} alt='' /></span>&nbsp;{t('message.common.btn.equipment')}
                                    </Button>
                                </div>
                                }
                                {info && info.bpFile &&
                                <div className="vr_btn">
                                    <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedBp} color="primary" onClick={()=>setImageFromFile(info.bpFile, info.imgFiles.length+1)}>
                                        <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/history_edu.png`} alt='' /></span>&nbsp;{t('message.common.btn.floor.plan')}
                                    </Button>
                                </div>
                                }
                            </div>

                            <div>
                                {info && info.vrFiles && info.vrFiles.map(function(item, i) {
                                    return (
                                <div key={i}><PanoViewerLayer info={info} idx={i+1} /></div>
                                    )
                                })}
                            </div>
                        </div>

                        <EquipmentImgFileModifyLayer equipmentId={info && info.id} setIsLoading={setParentIsLoading} />
                    </div>
                    
                    <div>
                        <div>
                            {info && info.files && info.files.map(function(item, i) {
                                return (
                            <div key={i} style={{width:"100%"}}><FileDownloadIcon file={item} viewFileName={true} iconSize="small" fontColor="#000" /></div>
                                )
                            })}
                        </div>
                    </div>


                    <div className='alert_phrase' style={{marginTop: "20px"}}>
                            {/* <MainCard content={false}>
                            <TableContainer>
                                {station && 
                                <Table aria-label="simple table" className="same_width">
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="th">{t('message.common.subtitle.station.mngrNm')}</TableCell>
                                        <TableCell>{station.mngrNm}</TableCell>
                                        <TableCell className="th">{t('message.common.subtitle.workingPart')}</TableCell>
                                        <TableCell>{station.workingPart.name}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="th">{t('message.common.subtitle.station.jobTitle')}</TableCell>
                                        <TableCell>{station.jobTitle}</TableCell>
                                        <TableCell className="th">{t('message.common.subtitle.station.assignedYmd')}</TableCell>
                                        <TableCell>{station.assignedYmd}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="th">{t('message.common.subtitle.station.eduCompletedYmd')}</TableCell>
                                        <TableCell>{station.eduCompletedYmd}</TableCell>
                                        <TableCell className="th"></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableBody>
                                </Table>
                                }
                            </TableContainer>
                            </MainCard> */}

                            <MainCard content={false}>
                            <TableContainer>
                                {info &&
                                <Table aria-label="simple table" className="same_width inner_padding">
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="th">{t('message.common.subtitle.equipment.level1')}</TableCell>
                                        <TableCell>{info.equipmentCtgr && info.equipmentCtgr.parent && info.equipmentCtgr.parent.parent && (info.equipmentCtgr.parent.parent.name || '')}</TableCell>
                                        <TableCell className="th">{t('message.common.subtitle.equipment.level3')}</TableCell>
                                        <TableCell>{info.equipmentCtgr && (info.equipmentCtgr.name || '')}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                                        <TableCell>{info.name}</TableCell>
                                        <TableCell className="th">{t('message.common.subtitle.equipment.number')}</TableCell>
                                        <TableCell>{info.equipmentNo}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="th">{t('message.common.subtitle.position')}</TableCell>
                                        <TableCell>{info.location}</TableCell>
                                        <TableCell className="th">{t('message.common.subtitle.mfCpnyNm')}</TableCell>
                                        <TableCell>{info.mfCpnyNm}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                                        <TableCell align="center" colSpan={3}>
                                            <div  style={{display:"flex"}}>
                                            <div style={{whiteSpace:"pre-line", textAlign:"left", width:"100%"}}>
                                                {info.remark}
                                            </div>
                                            <EquipmentRemarkModifyLayer equipmentId={info.id} setIsLoading={setParentIsLoading} />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="th">{t('message.common.subtitle.madeYmd')}</TableCell>
                                        <TableCell>{info.madeYmd}</TableCell>
                                        <TableCell style={{textAlign:"right"}} colSpan={2}>
                                            <NavLink href={`/equipment/${info.id}`}><Button variant="contained" style={{marginRight:"7px"}}>{t('message.common.btn.equipment.status.view')}</Button></NavLink>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                </Table>
                                }
                            </TableContainer>
                        </MainCard>
                    </div>

                    <div className='alert_phrase' style={{marginTop: "20px"}}>
                        <ConstantInspectionListTable equipmentAlerts={equipmentAlerts} setIsLoading={setParentIsLoading}/>
                    </div>

                    <div style={{marginTop:"10px"}}>
                        <Link to={`/${linkTarget}`+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link>
                    </div>
                </Col>

                <Col sm={8} className="sub_right">
                    {equipmentAlert && equipmentAlert.fllwActionType === 'O1_WAIT' &&
                    <MainCard content={false} style={{marginBottom:"10px"}}>
                        <TableContainer>
                        <Table aria-label="simple table" className="red_table maint_table">
                            <TableBody>
                            <TableRow className='td_red'>
                                <TableCell className="th" style={{width:"150px"}}>{t('message.common.chip.constantInspection')}</TableCell>
                                <TableCell>
                                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                                    <div style={{marginLeft:"25px"}}>{equipmentAlert.fllwActionType && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}</div>
                                    { role !== ROLE.MO.code &&
                                    <div style={{marginRight:"5px"}}>
                                        <ConstantInspectionFollowActionTypeRequestLayer alertId={equipmentAlert.id} setIsLoading={setParentIsLoading} />
                                    </div>
                                    }
                                </div>
                                </TableCell>
                            </TableRow>
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </MainCard>
                    }
                    {equipmentAlert && equipmentAlert.fllwActionType === 'O2_OBSERVE' 
                                 && (attentionObservation?.status === 'V') &&
                        //&& (attentionObservation.endYmd === undefined || (attentionObservation.endYmd && parseInt(attentionObservation.endYmd.replaceAll('-','')) >= parseInt(todayNum))) &&
                    <MainCard content={false} style={{marginBottom:"10px"}}>
                        <TableContainer>
                        <Table aria-label="simple table" className="red_table maint_table">
                            <TableBody>
                            <TableRow className='td_red'>
                                <TableCell className="th" style={{width:"150px"}}>{t('message.common.btn.observe')}</TableCell>
                                <TableCell>{attentionObservation && attentionObservation.regYmd} ~ {attentionObservation && attentionObservation.endYmd}</TableCell>
                                { role !== ROLE.MO.code &&
                                <TableCell>
                                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                                    <div>{attentionObservation && attentionObservation.remark}</div>
                                    <div style={{marginRight:"5px",minHeight:"40px"}}>
                                        {/* {(parseInt(attentionObservation.endYmd.replaceAll('-','')) > parseInt(todayNum)) && */}
                                        <Button variant="contained" onClick={()=>{risUserModal(attentionObservation.id)}}>{t('message.common.subtitle.observe.release')}</Button>
                                        {/* } */}
                                    </div>
                                </div>
                                </TableCell>
                                }
                            </TableRow>
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </MainCard>
                    }
                    {equipmentAlert && equipmentAlert.fllwActionType === 'O3_MNT' 
                        && (maintenanceTask === null || (maintenanceTask && maintenanceTask.status === 'O1_R')) &&
                    <MainCard content={false} style={{marginBottom:"10px"}}>
                        <TableContainer>
                        <Table aria-label="simple table" className="red_table maint_table">
                            <TableBody>
                            <TableRow className='td_red'>
                                <TableCell className="th" style={{width:"150px"}}>{t('message.common.title.maintenance')}</TableCell>
                                <TableCell>{t('message.common.text.wait')}</TableCell>
                                { role !== ROLE.MO.code &&
                                <TableCell>
                                    <div style={{textAlign:"right"}}>
                                    {equipmentAlert.fllwActionType === 'O3_MNT' && (maintenanceTask === null || (maintenanceTask && maintenanceTask.status === 'O1_R')) && 
                                    // <><MaintenanceRequestLayer alertId={equipmentAlert.id} setIsLoading={setParentIsLoading} isOpen={isFollowActionTypeOpen} setIsFollowActionTypeOpen={setIsFollowActionTypeOpen} type={isFollowActionTypeOpen?"modify":null} />&nbsp;&nbsp;</>}
                                    <><MaintenanceRequestLayer alertId={equipmentAlert.id} setIsLoading={setParentIsLoading} type="modify" />&nbsp;&nbsp;</>}
                                    {(linkTarget === 'maintenance-history' && maintenanceTask && maintenanceTask.status !== 'O4_V' && (role === ROLE.SA.code || role === ROLE.WA.code)) &&
                                    <>&nbsp;&nbsp;<Button variant="contained" color="error" onClick={()=>{handleDeleteBtnClick(maintenanceTask.id)}}>
                                        {t('message.common.btn.delete')}
                                    </Button></>
                                    }
                                    </div>
                                </TableCell>
                                }
                            </TableRow>
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </MainCard>
                    }

                    <div className='alert_phrase'>
                        <EquipmentAlertInfoCard equipmentAlert={equipmentAlert} maintenanceTask={maintenanceTask} setIsLoading={setParentIsLoading}/>
                    </div>

                    <AttentionObservationInfoCard attentionObservation={attentionObservation} setIsLoading={setParentIsLoading}/>

                    {equipmentAlert.fllwActionType === 'O3_MNT' && maintenanceTask && maintenanceTask.status !== 'O1_R' && 
                    <div className='alert_phrase' style={{marginTop: "20px"}}>
                        <MaintenanceTaskInfoCard maintenanceTask={maintenanceTask} setIsLoading={setParentIsLoading} linkTarget={linkTarget}/>
                    </div>
                     }
                </Col>
            </Row>
        </div>
		  )
    }
}

export default EquipmentAlertViewMaintenancePage;